/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CarpCategoryListSubCategoryResponse } from './CarpCategoryListSubCategoryResponse';

export type CarpCategoryListSubCategoryResponseApiRespoonse = {
    data?: CarpCategoryListSubCategoryResponse;
    status?: CarpCategoryListSubCategoryResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CarpCategoryListSubCategoryResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

